import React from "react";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Reply } from "@material-ui/icons";
import SendIcon from "@material-ui/icons/Send";
import MicIcon from "@material-ui/icons/Mic";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import WaveformVisualizer from "../WaveformVisualizer";
import useMessageInputStyles from "../messageInputStyles";

const ActionButtons = (props) => {
  const {
    inputMessage,
    loading,
    sendingText,
    recording,
    analyserRef,
    ticketStatus,
    handleSendMessage,
    handleCancelAudio,
    handleUploadAudio,
    handleStartRecording,
    handleOpenModalForward,
    showSelectMessageCheckbox,
    allowAudio = true
  } = props;
  const classes = useMessageInputStyles();

  const handleCancelSelection = () => {
    const { setShowSelectMessageCheckbox, setSelectedMessages } = props;
    setShowSelectMessageCheckbox(false);
    setSelectedMessages([]);
  };

  if (showSelectMessageCheckbox) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {/* ✅ BOTÓN CANCELAR */}
        <IconButton
          aria-label="cancelSelection"
          component="span"
          onClick={handleCancelSelection}
          disabled={loading}
          style={{ color: '#f44336' }}
          title="Cancelar selección"
        >
          <HighlightOffIcon className={classes.sendMessageIcons} />
        </IconButton>
        <IconButton
          aria-label="forwardMessage"
          component="span"
          onClick={handleOpenModalForward}
          disabled={loading}
        >
          <Reply className={classes.ForwardMessageIcons} />
        </IconButton>
      </div>
    );
  } else if (inputMessage || sendingText || !allowAudio) {
    return (
      <IconButton
        aria-label="sendMessage"
        component="span"
        onClick={handleSendMessage}
        disabled={loading || (!inputMessage && !sendingText)}
      >
        {sendingText ? (
          <CircularProgress size={22} className={classes.audioLoading} />
        ) : (
          <SendIcon className={classes.sendMessageIcons} />
        )}
      </IconButton>
    );
  } else if (recording) {
    return (
      <div className={classes.recorderWrapper}>
        <IconButton
          aria-label="cancelRecording"
          component="span"
          fontSize="large"
          disabled={loading}
          onClick={handleCancelAudio}
        >
          <HighlightOffIcon className={classes.cancelAudioIcon} />
        </IconButton>
        {loading ? (
          <div>
            <CircularProgress className={classes.audioLoading} />
          </div>
        ) : (
          <WaveformVisualizer analyserRef={analyserRef} />
        )}

        <IconButton
          aria-label="sendRecordedAudio"
          component="span"
          onClick={handleUploadAudio}
          disabled={loading}
        >
          <CheckCircleOutlineIcon className={classes.sendAudioIcon} />
        </IconButton>
      </div>
    );
  } else {
    return (
      <IconButton
        aria-label="showRecorder"
        component="span"
        disabled={loading || ticketStatus !== "open"}
        onClick={handleStartRecording}
      >
        <MicIcon className={classes.sendMessageIcons} />
      </IconButton>
    );
  }
};

export default ActionButtons;
